import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Wording shared by the tooltip and the badge's accessible name, so keyboard
// and screen-reader users get the same explanation pointer users get.
const HIDDEN_EXPLANATION =
  "This stream has no live classes and is not set to call-to-enroll, so the website leaves it out until the branch offers it again. Its slot is kept.";

// The ordered strip the branch shows on its public website page. Row order is
// the slot order — index 0 is the first card — so the up/down buttons are the
// only thing that decides what a parent sees first.
export function FeaturedCourseSlots({
  featured,
  maxFeatured,
  disabled,
  onMoveUp,
  onMoveDown,
  onRemove,
}) {
  return (
    <Table size="small" aria-label="Featured courses">
      <TableHead>
        <TableRow>
          <TableCell style={{ width: "70px" }} align="center">
            Slot
          </TableCell>
          <TableCell>Stream</TableCell>
          <TableCell align="center" style={{ width: "150px" }}>
            On the website
          </TableCell>
          <TableCell align="center" style={{ width: "160px" }}>
            Order
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {featured.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} align="center">
              <p className="text-muted my-3">
                No featured streams yet. Pick up to {maxFeatured} from the list
                below.
              </p>
            </TableCell>
          </TableRow>
        ) : (
          featured.map((course, index) => (
            <TableRow key={course.branch_course_id}>
              <TableCell align="center">
                <span className="label label-lg label-inline label-light-primary font-weight-bolder">
                  {index + 1}
                </span>
              </TableCell>
              <TableCell>
                <span className="font-weight-bolder d-block">
                  {course.course_name}
                </span>
                <span className="text-muted font-size-sm">
                  {course.course_code}
                </span>
              </TableCell>
              <TableCell align="center">
                {Number(course.publicly_visible) === 1 ? (
                  <span className="label label-inline label-light-success">
                    Showing
                  </span>
                ) : (
                  <OverlayTrigger
                    overlay={
                      <Tooltip id={`hidden-${course.branch_course_id}`}>
                        {HIDDEN_EXPLANATION}
                      </Tooltip>
                    }
                  >
                    {/* Focusable so the tooltip opens on keyboard focus, and
                        labelled so the reason is announced either way. */}
                    <span
                      className="label label-inline label-light-warning"
                      tabIndex={0}
                      role="note"
                      aria-label={`Hidden. ${HIDDEN_EXPLANATION}`}
                    >
                      Hidden
                    </span>
                  </OverlayTrigger>
                )}
              </TableCell>
              <TableCell align="center">
                <button
                  type="button"
                  className="btn btn-icon btn-light btn-hover-primary btn-sm mr-1"
                  title="Move up"
                  aria-label={`Move ${course.course_name} up`}
                  disabled={disabled || index === 0}
                  onClick={() => onMoveUp(index)}
                >
                  <i className="fa fa-arrow-up" />
                </button>
                <button
                  type="button"
                  className="btn btn-icon btn-light btn-hover-primary btn-sm mr-1"
                  title="Move down"
                  aria-label={`Move ${course.course_name} down`}
                  disabled={disabled || index === featured.length - 1}
                  onClick={() => onMoveDown(index)}
                >
                  <i className="fa fa-arrow-down" />
                </button>
                <button
                  type="button"
                  className="btn btn-icon btn-light btn-hover-danger btn-sm"
                  title="Remove from featured"
                  aria-label={`Remove ${course.course_name} from featured`}
                  disabled={disabled}
                  onClick={() => onRemove(course.branch_course_id)}
                >
                  <i className="fa fa-times text-danger" />
                </button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
